export const getCleanText = (value: string) => {
  const trimmed = value.trim();
  let clean = '';
  let spaceCount = 0;
  for (let i = 0; i < trimmed.length; i++) {
    if (trimmed[i] === ' ') {
      if (spaceCount === 0) {
        clean += trimmed[i];
      }
      spaceCount++;
    } else {
      clean += trimmed[i];
      spaceCount = 0;
    }
  }
  return clean;
};
